<div class="sidebar-container" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <!-- Header: logo row + arrow row -->
  <header class="sidebar-header">
    <!-- Row 1: Logo and Title -->
    <div class="logo-title-placeholder">
      <div class="logo-wrapper">
        <img src="images/gopher_support.png" alt="Gopher Logo" class="logo" />
      </div>
      <span class="title" *ngIf="sidebarState !== 'collapsed'">Platform Admin</span>
    </div>
  </header>

  <!-- Scrollable Navigation Body -->
  <nav class="sidebar-nav">
    <ul>
      <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: navigationItems }"></ng-container>
    </ul>
  </nav>

  <!-- Pinned Footer: signed-in admin — opens the account menu -->
  <footer class="sidebar-footer">
    <button
      type="button"
      class="account-link"
      [matMenuTriggerFor]="accountMenu"
      [matTooltip]="userInfo?.name || 'Platform Admin'"
      [matTooltipDisabled]="sidebarState !== 'collapsed'"
      matTooltipPosition="right"
      matTooltipClass="sidebar-tooltip"
      aria-label="Account menu"
    >
      <img
        [src]="userInfo?.avatarUrl || 'images/gopher.svg'"
        referrerpolicy="no-referrer"
        alt="User Avatar"
        class="user-avatar"
      />
      <span class="nav-text font-normal" [class.nav-text--hidden]="sidebarState === 'collapsed'">{{ userInfo?.name || 'Platform Admin' }}</span>
    </button>

    <mat-menu #accountMenu="matMenu" yPosition="above" xPosition="after" class="account-menu">
      <div class="account-menu-header">
        <div class="account-menu-name">{{ userInfo?.name || 'Platform Admin' }}</div>
        <div class="account-menu-email" *ngIf="userInfo?.email">{{ userInfo?.email }}</div>
      </div>
      <button mat-menu-item type="button" (click)="logout()">
        <span class="account-menu-item">
          <lib-cdw-icon icon="logout" size="20px" class="account-menu-icon"></lib-cdw-icon>
          <span>Sign out</span>
        </span>
      </button>
    </mat-menu>
  </footer>
</div>

<!-- Floating edge toggle: half-hangs off the sidebar's right edge.
     Sibling of .sidebar-container (which is overflow:hidden) so it isn't
     clipped; positioned against the fixed :host right edge so it tracks the
     64↔300px width transition automatically. -->
<button
  type="button"
  class="edge-toggle"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  (click)="onArrowClick()"
  [attr.aria-label]="
    sidebarState === 'expanded' ? 'Close sidebar'
      : sidebarState === 'peeking' ? 'Pin sidebar open'
      : 'Open sidebar'
  "
  [attr.aria-pressed]="sidebarState === 'expanded'"
  [matTooltip]="
    sidebarState === 'expanded' ? 'Close sidebar'
      : sidebarState === 'peeking' ? 'Pin sidebar open'
      : 'Open sidebar'
  "
  matTooltipPosition="right"
  matTooltipClass="sidebar-tooltip"
>
  <lib-cdw-icon [icon]="arrowIcon"></lib-cdw-icon>
</button>

<!-- Recursive Template for Navigation Items -->
<ng-template #recursiveList let-items>
  <li *ngFor="let item of items" [class.is-expanded]="item.isExpanded">
    <!-- Case 1: Item is a Link -->
    <a
      *ngIf="item.route && !item.children && !item.externalLink"
      [routerLink]="item.route"
      class="h-[72px]"
      [class.active-link]="item.isActive"
      (click)="onLeafItemClick()"
      [matTooltip]="item.title"
      [matTooltipDisabled]="sidebarState !== 'collapsed'"
      matTooltipPosition="right"
      matTooltipClass="sidebar-tooltip"
    >
      <lib-cdw-icon class="nav-icon" *ngIf="item.icon" [icon]="item.icon"></lib-cdw-icon>
      <span class="nav-bullet" *ngIf="!item.icon">•</span>
      <span class="nav-text" [class.nav-text--hidden]="sidebarState === 'collapsed'">{{ item.title }}</span>
    </a>

    <!-- Case 2: Item is an External Link -->
    <a
      *ngIf="item.route && item.externalLink"
      [href]="item.route"
      target="_blank"
      rel="noopener noreferrer"
      class="h-[72px]"
      (click)="onLeafItemClick()"
      [matTooltip]="item.title"
      [matTooltipDisabled]="sidebarState !== 'collapsed'"
      matTooltipPosition="right"
      matTooltipClass="sidebar-tooltip"
    >
      <lib-cdw-icon class="nav-icon" *ngIf="item.icon" [icon]="item.icon"></lib-cdw-icon>
      <span class="nav-bullet" *ngIf="!item.icon">•</span>
      <span class="nav-text" [class.nav-text--hidden]="sidebarState === 'collapsed'">{{ item.title }}</span>
      <lib-cdw-icon class="external-icon" *ngIf="sidebarState !== 'collapsed'" icon="open_in_new"></lib-cdw-icon>
    </a>

    <!-- Case 3: Item is Expandable (has children) -->
    <button
      type="button"
      *ngIf="item.children && item.children.length > 0"
      (click)="toggleItemExpansion(item)"
      [attr.aria-expanded]="item.isExpanded"
      [class.active-link]="item.isActive"
      class="h-[72px]"
      [matTooltip]="item.title"
      [matTooltipDisabled]="sidebarState !== 'collapsed'"
      matTooltipPosition="right"
      matTooltipClass="sidebar-tooltip"
    >
      <lib-cdw-icon class="nav-icon" *ngIf="item.icon" [icon]="item.icon"></lib-cdw-icon>
      <span class="nav-bullet" *ngIf="!item.icon">•</span>
      <span class="nav-text" [class.nav-text--hidden]="sidebarState === 'collapsed'">{{ item.title }}</span>
      <lib-cdw-icon
        class="expand-icon"
        *ngIf="sidebarState !== 'collapsed'"
        [icon]="item.isExpanded ? 'expand_less' : 'expand_more'"
      >
      </lib-cdw-icon>
    </button>

    <!-- Recursive Call for Children -->
    <ul
      class="sub-menu"
      *ngIf="item.children && item.children.length > 0 && item.isExpanded && sidebarState !== 'collapsed'"
    >
      <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: item.children }"></ng-container>
    </ul>
  </li>
</ng-template>
